let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aBPGJ")).then(() => parcelRequire('ehnQj'));